var state = {
  search: [
    {
      name: "按上传者姓名",
      value: 1
    },
    {
      name: "按文件名称",
      value: 2
    }
  ],
  select: 2, //默认搜索条件
  searchcontent: "", //搜索内容
  searchtype: 2, //搜索类型
  // 部门
  canup: false, //能否继续执行
  nodepartitle: "", //当前部门active 共享文件夹
  nodepartinfo: "", //当前部门信息
  departmentlist: [], //加入的部门列表
  departmentall: [], //全部部门列表
  departmentuser: [], //部门用户列表
  deresour: [], //资源
  deloading: true, //加載中
  depage: 1, //部门资源列表页数
  depagesize: 20, //部门资源列表条数
  detotal: 0, //总数
  pid: 0, //默认层级
  pathlength: 0, //文件路径长度
  path: [], //文件路径
  order: "desc", //desc新到旧 asc 旧到新

  setusers: [], //权限设置人员
  //系统设置
  systemdeluser: [], //部门人员

  // ---------------------share 共享文件夹
  shareselect: 2, //默认搜索条件
  sharesearchcontent: "", //搜索内容
  sharesearchtype: 2, //搜索类型
  shareresour: [], //资源
  shareloading: true, //加載中
  sharepage: 1, //部门资源列表页数
  sharepagesize: 30, //部门资源列表条数
  sharetotal: 0, //总数
  sharepid: 0, //默认层级
  sharepathlength: 0, //文件路径长度
  sharepath: [], //文件路径
  fileType: "depkejian" // 文件类型
};
export default state;



// WEBPACK FOOTER //
// ./src/store/modules/department/state.js